import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import { polyfill } from 'react-lifecycles-compat';
import createRef from '@roo/create-react-ref/createRef';
import { clone } from '@utiljs/clone';

var TagInput = /*#__PURE__*/function (_React$Component) {
  _inherits(TagInput, _React$Component);

  var _super = _createSuper(TagInput);

  function TagInput() {
    var _this;

    _classCallCheck(this, TagInput);

    _this = _super.apply(this, arguments);
    _this.state = {
      inputValue: '',
      value: _this.props.defaultValue
    };
    _this.isFocus = false;
    _this.inputRef = createRef();

    _this.addTag = function (inputValue) {
      var _this$props = _this.props,
          value = _this$props.value,
          onAdd = _this$props.onAdd,
          onChange = _this$props.onChange;
      var tagList = _this.state.value;

      if (tagList.indexOf(inputValue) > -1) {
        _this.setState({
          inputValue: ''
        });

        return;
      }

      var data = clone(tagList);
      data.push(inputValue);

      if (onAdd) {
        onAdd(inputValue);
      }

      if (onChange) {
        onChange(data);
      }

      if (value === undefined) {
        _this.setState({
          value: data,
          inputValue: ''
        });
      } else {
        _this.setState({
          inputValue: ''
        });
      }
    };

    _this.removeTag = function (inputValue) {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          onRemove = _this$props2.onRemove,
          onChange = _this$props2.onChange;
      var tagList = _this.state.value;
      var data = tagList.filter(function (item) {
        return item !== inputValue;
      });

      if (onRemove) {
        onRemove(inputValue);
      }

      if (onChange) {
        onChange(data);
      }

      if (value === undefined) {
        _this.setState({
          value: data,
          inputValue: ''
        });
      } else {
        _this.setState({
          inputValue: ''
        });
      }
    };

    _this.handleBlur = function () {
      _this.isFocus = false;

      _this.inputRef.current.blur();
    };

    _this.handleFocus = function () {
      _this.isFocus = true;

      _this.inputRef.current.focus();
    };

    _this.handleOnChange = function (e) {
      var value = e.target.value;

      _this.setState({
        inputValue: value
      });
    };

    _this.handleKeyUp = function (e) {
      var _this$state = _this.state,
          value = _this$state.value,
          inputValue = _this$state.inputValue;

      if ((e.key === 'Enter' || e.keyCode === 13) && inputValue && _this.isFocus) {
        _this.addTag(inputValue);
      }

      if ((e.key === 'Backspace' || e.keyCode === 8) && inputValue === '' && _this.isFocus && value.length) {
        var removeValue = value[value.length - 1];

        _this.removeTag(removeValue);
      }
    };

    return _this;
  }

  _createClass(TagInput, [{
    key: "renderTagClose",
    value: function renderTagClose(tag) {
      var _this2 = this;

      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          readOnly = _this$props3.readOnly;
      if (disabled || readOnly) return null;
      return /*#__PURE__*/React.createElement("i", {
        className: "roo-icon roo-icon-times-circle",
        onClick: function onClick() {
          return _this2.removeTag(tag);
        }
      });
    }
  }, {
    key: "renderTag",
    value: function renderTag() {
      var _this3 = this;

      return (this.state.value || []).map(function (tag) {
        return /*#__PURE__*/React.createElement("span", {
          className: "roo-tag roo-tag-gray",
          key: tag
        }, tag, _this3.renderTagClose(tag));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          disabled = _this$props4.disabled,
          readOnly = _this$props4.readOnly,
          className = _this$props4.className,
          style = _this$props4.style,
          placeholder = _this$props4.placeholder;
      var value = this.state.value;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(['form-control roo-input-tag', {
          disabled: disabled
        }, className]),
        style: style,
        onClick: this.handleFocus
      }, /*#__PURE__*/React.createElement("div", {
        className: "tags-box"
      }, this.renderTag(), /*#__PURE__*/React.createElement("input", {
        placeholder: value && value.length ? '' : placeholder,
        ref: this.inputRef,
        disabled: disabled,
        readOnly: readOnly,
        type: "text",
        value: this.state.inputValue,
        onChange: this.handleOnChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyUp: this.handleKeyUp
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.value !== undefined) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return TagInput;
}(React.Component);

TagInput.propTypes = {
  defaultValue: PropTypes.array,
  value: PropTypes.array,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  placeholder: PropTypes.string
};
TagInput.defaultProps = {
  defaultValue: [],
  value: undefined,
  disabled: false,
  readOnly: false,
  onAdd: function onAdd() {},
  onRemove: function onRemove() {},
  onChange: function onChange() {},
  className: '',
  style: {},
  placeholder: ''
};
polyfill(TagInput);
export default TagInput;